import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MessageService } from '@pages/components/message/message.service';

import { Property, Country } from './property.model';
import {
  countryBuilderUI,
  propertiesBuilderUI,
  propertyDetailsBuilderUI
} from './property.mapper';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  baseUrl = environment.apiUrl;

  constructor(
    private _http: HttpClient,
    private _notification: MessageService
  ) {}

  getCountry(): Observable<Country> {
    return this._http
      .get(`${this.baseUrl}/country`)
      .pipe(map(countryBuilderUI));
  }

  getProperties(params): Observable<Property> {
    return this._http
      .get(`${this.baseUrl}/properties`, { params: params })
      .pipe(map(propertiesBuilderUI));
  }

  getPropertyDetails(id): Observable<Property> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}`)
      .pipe(map(propertyDetailsBuilderUI));
  }
}
